module.exports = __webpack_public_path__ + "img/groundGlass.dc7b2bb7.png";